const config = require("../../config.json"); 
const lang = require('./lang/lang.json')

export default {
    submitLead,
    postbackTaboola,
    trackUser
}

const getDomainWithoutSubdomain = url => {
    const urlParts = new URL(url).hostname.split('.')
  
    return urlParts
      .slice(0)
      .slice(-(urlParts.length === 4 ? 3 : 2))
      .join('.')
  }

// Funzione per validare IP address
function isValidIP(ip) {
    // Controlla se l'IP è vuoto, undefined, null o contiene placeholder
    if (!ip || ip === "" || ip === undefined || ip === null || ip === "{ip}") {
        return false;
    }

    // Controlla se è un IPv4 valido
    const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    
    // Controlla se è un IPv6 valido (versione semplificata)
    const ipv6Regex = /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$|^::1$|^::$/;
    
    // Se passa il test regex per IPv4, controlla anche che non sia in range riservati
    if (ipv4Regex.test(ip)) {
        const parts = ip.split('.').map(Number);
        
        // Esclude IP privati, localhost, broadcast, ecc.
        if (
            // IP privati classe A (10.0.0.0/8)
            parts[0] === 10 ||
            // IP privati classe B (172.16.0.0/12)
            (parts[0] === 172 && parts[1] >= 16 && parts[1] <= 31) ||
            // IP privati classe C (192.168.0.0/16)
            (parts[0] === 192 && parts[1] === 168) ||
            // Localhost (127.0.0.0/8)
            parts[0] === 127 ||
            // IP link-local (169.254.0.0/16)
            (parts[0] === 169 && parts[1] === 254) ||
            // IP multicast (224.0.0.0/4)
            parts[0] >= 224 ||
            // IP riservati (0.0.0.0/8)
            parts[0] === 0
        ) {
            return false;
        }
        
        return true;
    }
    
    // Controlla IPv6
    if (ipv6Regex.test(ip)) {
        // Esclude localhost IPv6
        if (ip === "::1" || ip === "::") {
            return false;
        }
        return true;
    }
    
    return false;
}
  

async function submitLead(param,locale){

    const domain = window.location.hostname;
    param.servizio = getDomainWithoutSubdomain(config[domain].servizio)
    param.sono = "uomo"
    param.cerco = "donna"
    param.ua =  navigator.userAgent
    param.fluxId =  param.fluxId ?  param.fluxId : config[domain].default_fluxid
    param.country = config[domain].default_language

    if(!param.clickid || param.clickid == "" || param.clickid == undefined){
        param.clickid = await recuperaClickid(param)
    }

    if(!isValidIP(param.ip)){
        param.ip = await recuperaIp()
    }

     

    return await fetch(config[domain].sigup_url,{ 
        method: 'post', 
        headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(param)
        }) 
        .then(response => response.json())
        .then(res => {
          console.log("submitLead response",res)
			if(res.result){
               console.log("°°° SUCCESS °°°")
                return {success:true,red_url:res.red_url}
            }else{
                if(res.userMail){
                    return {success:false,red_url:res.userMail}
                }
                console.log("°°°° ERROR °°°°",res.message)
                logToBackend(errorCodes(res.message,locale))
                return {success:false,message:errorCodes(res.message,locale),userMail:res.userMail}
          
            }
		})
        .catch(err =>{
            logToBackend(err)
            console.log("Errore submitLead - TEKKA",err)
        }
    )

}



function errorCodes(code,locale){

  const codeNumber = code.split("-");
console.log("errorCodes",codeNumber,locale)
  switch(codeNumber[1]) {
      case "1000":
        return lang[locale]["errors"].email_esistente
      case "1001":
        return lang[locale]["errors"].fingerprint
      case "1003":
        return lang[locale]["errors"].fingerprint
      case "1004":
        return lang[locale]["errors"].email_non_valida
      case "1005":
        return lang[locale]["errors"].email_vietata
      case "1006":
        window.location.replace(code.userMail)
      case "1007":
        return lang[locale]["errors"].troppi_tentativi
      case "1008":
        return lang[locale]["errors"].account_disabilitato
      case "1009":
        return lang[locale]["errors"].welcome_gia_inviata
      default:
        return lang[locale]["errors"].qualcosa_storto
    } 
}




async function recuperaClickid(param){

    const url = "https://uniallel-conary.icu/dcde08b5-3710-4bc8-9d3f-21dd4ce2aacc?trafficSource="+param.source+"&type="+param.campid+"&page="+window.location.pathname+"&servizio="+param.servizio
    return await fetch(url)
    .then(response => response.json())
    .then(res => {
      return res.clickid
    }) 
}



async function recuperaIp(){

    const url = "https://api.trkmyclick.com/get/ip"
    return await fetch(url)
    .then(response => response.json())
    .then(res => {
      return res.ip
    }) 
}


async function logToBackend(messaggio){
    const oggetto = {
      subject:"Errore OFFER" + window.location.pathname,
      messaggio:messaggio
    }
    return await fetch("https://api.trkmyclick.com/log/client",{ 
      method: 'post', 
      headers: {
        'Accept': 'application/json, text/plain, */*',
              'Content-Type': 'application/json'
      },
      body: JSON.stringify(oggetto)
    }).then(()=>{return true})
    .catch((err) => {
      console.log("Problemi con logToBackend",err.message)
    })
  }



  async function postbackTaboola(){

      const ext_id = getUrlParameter("ext_id")
   
      var url = "https://trc.taboola.com/actions-handler/log/3/s2s-action?click-id="+ext_id+"&name=click_landing&partner-name=1479412&revenue=0&currency=EUR"

      return await fetch(url)
        .then(res =>  {
            return true
        }).catch(err=>{
            console.log("\x1b[33m%s\x1b[0m","ERRORE PIXEL",err)
            return false
            
        })

  }



  function getUrlParameter(parameter){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    var param = urlParams.get(parameter) ? urlParams.get(parameter):null
    return param
  }



  
async function trackUser(fingerprint,context){


  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const domain = window.location.hostname;
  var servizio = urlParams.get('service') ? urlParams.get('service'):null
  var zone_id = urlParams.get('zonaid') ? urlParams.get('zonaid'):null
  var campid = urlParams.get('campid') ? urlParams.get('campid'):null
  var source = urlParams.get('source') ? urlParams.get('source'):null


  return await fetch("https://track.advdog.info/collect/lander", {
    method: 'POST',
    headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
    },
    body: JSON.stringify({fingerprint:fingerprint,"country": context.lang,servizio:servizio,domain:domain,zone_id:zone_id,isAdult:context.isAdult,campid:campid,source:source})
  })
  .then(response => response.json())
  .then(response => {
    if(!response.testing){
      if(response.red){
          return response.red
      }else{
          return null
      }
    }
  })
}